import * as type from "../types";
import { get, deleteReq, post, put, patch } from "../../config/Requests";
import { rentSettingsRoute, rentOperatorsRoute, rentPricingRoute, rentClientRoute,
            rentOperatorsPasswordExpirationRoute, rentOperatorsPasswordResetRoute, rentClientImportRoute } from './../../config/routes';
import { setData } from './../helpers';
import { openSnackbarInfoDispatch } from './requestAction';
import t from "../../languages/pl";

export const setRent = (rent) => {
    return dispatch => {
        dispatch({
            type: type.SET_RENT,
            value: rent
        });
    };
};

export const setAvailableClients = (clients) => {
    return dispatch => {
        dispatch({
            type: type.SET_CLIENTS,
            value: clients
        });
    };
};

export const getRentSettings = () => {
    return dispatch => {
        get(
            dispatch,
            rentSettingsRoute,
            { },
            response => setData(dispatch, type.SET_RENT_SETTINGS, response)
        );
    };
};

export const resetRentSettingsToDefaults = () => {
    return dispatch => {
        deleteReq(
            dispatch,
            rentSettingsRoute,
            null,
            response => {
                dispatch({
                    type: type.SET_RENT_SETTINGS,
                    value: response.data
                });
                openSnackbarInfoDispatch(dispatch, t.restoredDefaultSetting);
            }
        );
    };
};

export const importClients = (importedClients) => {
    return (dispatch) => {
        post(
            dispatch,
            rentClientImportRoute,
            importedClients,
            () => {
                window.location.reload();
            }
        );
    };
};

export const operatorPasswordExpirationChange = (id, data) => {
    return (dispatch) => {
        patch(
            dispatch,
            rentOperatorsPasswordExpirationRoute,
            { operator_id: id },
            { waznosc_hasla: data},
            () => {
                openSnackbarInfoDispatch(dispatch, t.passwordExpirationDateHasBeenChanged);
            }
        );
    };
};

//clients

export const getRentClients = () => {
    return dispatch => {
        get(
            dispatch,
            rentClientRoute,
            { },
            response => setData(dispatch, type.SET_RENT_CLIENTS, response)
        );
    };
};

export const addRentClient= data => {
    return (dispatch, getState) => {
        let clients = getState().rentReducer.clients;
        post(
            dispatch,
            rentClientRoute,
            data,
            response => {
                const addedClient= {
                    ...response.data,
                    ...data
                };
                const newClients = [
                    ...clients,
                    addedClient
                ];
                dispatch({
                    type: type.SET_RENT_CLIENTS,
                    value: newClients
                });
                openSnackbarInfoDispatch(dispatch, t.clientAdded);
            }
        );
    };
};

export const putRentClient= (id, data) => {
    return (dispatch) => {
        put(
            dispatch,
            rentClientRoute,
            {klient_id: id},
            {...data},
            () => {
                dispatch({
                    type: type.UPDATE_RENT_CLIENT,
                    value: data
                });
                openSnackbarInfoDispatch(dispatch, t.clientDataUpdated);
            }
        );
    };
};

export const deleteRentClient = id => {
    let idToDelete = { klient_id: id };
    return (dispatch, getState) => {
        let clients = getState().rentReducer.clients;
        let newClients = clients.filter(client => client.klient_id !== id);
        deleteReq(
            dispatch,
            rentClientRoute,
            idToDelete,
            { },
            () => {
                dispatch({
                    type: type.SET_RENT_CLIENTS,
                    value: newClients
                });
                openSnackbarInfoDispatch(dispatch, t.clientHasBeenRemoved);
            }
        );
    };
};


//operators

export const getRentOperators = () => {
    return dispatch => {
        get(
            dispatch,
            rentOperatorsRoute,
            { },
            response => setData(dispatch, type.SET_RENT_OPERATORS, response)
        );
    };
};

export const addRentOperator = data => {
    return (dispatch, getState) => {
        const operators = getState().rentReducer.operators;
        post(
            dispatch,
            rentOperatorsRoute,
            data,
            response => {
                const addedOperator= {
                    ...response.data,
                    ...data
                };
                const newOperators = [
                    ...operators,
                    addedOperator
                ];
                dispatch({
                    type: type.SET_RENT_OPERATORS,
                    value: newOperators
                });
                openSnackbarInfoDispatch(dispatch, t.operatorAdded);
            }
        );
    };
};

// export const putRentOperator = (id, data) => {
//     delete data.operator_id;
//     return (dispatch, getState) => {
//         let operators = getState().rentReducer.operators;
//         let updatedOperator = operators.filter(operator => operator.operator_id === id);
//         const index = updatedOperator.findIndex(updatedOperator => updatedOperator.operator_id === id);
//         put(
//             dispatch,
//             rentOperatorsRoute,
//             {operator_id : id},
//             {...data},
//             () => {
//                 operators[index] = updatedOperator;
//                 openSnackbarInfoDispatch(dispatch, "Zaktualizowano dane operatora!");
//             }
//         );
//     };
// };

export const putRentOperator = (id, data)  => {
    return (dispatch) => {
        put(
            dispatch,
            rentOperatorsRoute,
            {operator_id: id},
            {...data},
            () => {
                dispatch({
                    type: type.UPDATE_RENT_OPERATORS,
                    value: data
                });
                openSnackbarInfoDispatch(dispatch, t.operatorDataUpdated);
            }
        );
    };
};

export const deleteRentOperator = id => {
    let idToDelete = { operator_id: id };
    return (dispatch, getState) => {
        let operators = getState().rentReducer.operators;
        let newOperators = operators.filter(operator => operator.operator_id !== id);
        deleteReq(
            dispatch,
            rentOperatorsRoute,
            idToDelete,
            () => {
                dispatch({
                    type: type.SET_RENT_OPERATORS,
                    value: newOperators
                });
                openSnackbarInfoDispatch(dispatch, t.operatorHasBeenRemoved);
            }
        );
    };
};

export const rentOperatorPasswordReset = (id) => {
    return dispatch => {
        get(
            dispatch,
            rentOperatorsPasswordResetRoute,
            {operator_id: id},
            () => {
                openSnackbarInfoDispatch(dispatch, t.operatorPasswordHasBeenReset);
            }
        );
    };
};


//pricing

export const getRentPricing = () => {
    return dispatch => {
        get(
            dispatch,
            rentPricingRoute,
            { },
            response => setData(dispatch, type.SET_RENT_PRICING, response)
        );
    };
};

export const addPricing = data => {
    return (dispatch, getState) => {
        const pricingList = getState().rentReducer.pricing;
        post(
            dispatch,
            rentPricingRoute,
            data,
            response => {
                const addedPricing= {
                    ...response.data,
                    ...data
                };
                const newPricingList = [
                    ...pricingList,
                    addedPricing
                ];
                dispatch({
                    type: type.SET_RENT_PRICING,
                    value: newPricingList
                });
                openSnackbarInfoDispatch(dispatch, t.pricingAdded);
            }
        );
    };
};

// export const putPricing = (id, data) => {
//     return (dispatch, getState) => {
//         let updatedPricingList = getState().rentReducer.pricing;
//         const index = updatedPricingList.findIndex(updatedPricing => updatedPricing.cennik_id === id);
//         put(
//             dispatch,
//             rentPricingRoute,
//             {cennik_id: id},
//             {...data},
//             () => {
//                 const updatedPricing = {
//                     cennik_id: id,
//                     ...data
//                 };
//                 updatedPricingList[index] = {...updatedPricing};
//                 dispatch({
//                     type: type.SET_RENT_PRICING,
//                     value: updatedPricingList
//                 });
//                 openSnackbarInfoDispatch(dispatch, "Zaktualizowano cennik!");
//             }
//         );
//     };
// };

export const putPricing = (id, data)  => {
    return (dispatch) => {
        put(
            dispatch,
            rentPricingRoute,
            {cennik_id: id},
            {...data},
            () => {
                dispatch({
                    type: type.UPDATE_RENT_PRICING,
                    value: data
                });
                openSnackbarInfoDispatch(dispatch, t.pricingDataUpdated);
            }
        );
    };
};



export const deleteRentPricing = id => {
    let idToDelete = { cennik_id: id };
    return (dispatch, getState) => {
        let pricingList = getState().rentReducer.pricing;
        let newPricingList = pricingList.filter(pricing => pricing.cennik_id !== id);
        deleteReq(
            dispatch,
            rentPricingRoute,
            idToDelete,
            () => {
                dispatch({
                    type: type.SET_RENT_PRICING,
                    value: newPricingList
                });
                openSnackbarInfoDispatch(dispatch, t.pricingHasBeenRemoved);
            }
        );
    };
};

//save button
export const changeSaveRentSettings = (name, value) => {
    return (dispatch, getState) => {
        let saveState = getState().rentReducer.readyToSave;
        saveState = {
            ...saveState,
            [name]: value
        };
        dispatch({
            type: type.CHANGE_SAVE_SETTINGS,
            value: saveState
        });
    };
};

export const sendChangedSettings = (data) => {
    return (dispatch) => {
        post(
            dispatch,
            rentSettingsRoute,
            data,
            () => {
                dispatch({
                    type: type.SET_RENT_SETTINGS,
                    value: data
                });
                openSnackbarInfoDispatch(dispatch, t.settingsHasBeedUpdated);
            }
        );
    };
};